import styled from '@emotion/styled';
import { Chip, Typography } from '@material-ui/core';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { SingleOfferFragment } from '../../../../graphql/generated/graphql_offer';
import { SPACING_REGULAR, SPACING_UNIT } from '../../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../../styleUtility/gridLayout';
import OrganizationNameWithIcon from '../../primitive/OrganizationNameWithIcon';

export interface Props {
  offer: Pick<SingleOfferFragment, 'id' | 'name' | 'jobId' | 'type' | 'matchingFormat' | 'organization'>;
  className?: string;
}

const OfferListItemHeader = ({ offer, className }: ClassAttributes<HTMLElement> & Props) => {
  return (
    <Root className={className}>
      <Title>{offer.name}</Title>
      <ProjectId>#{offer.id}</ProjectId>
      <ProjectTypeValue noWrap>{offer.type}</ProjectTypeValue>
      <ChipAndOrganization>
        {offer.matchingFormat == 'competition' ? (
          <CompetitionChip
            label={<FormattedMessage id="show_creation_page.label.competition" />}
            variant="outlined"
            color="primary"
            icon={<PeopleOutlineIcon />}
          />
        ) : null}
        <OrganizationName name={offer.organization.name} />
      </ChipAndOrganization>
    </Root>
  );
};

const Root = styled('div')({
  ...gridLayoutContainer({
    columns: [`calc(100% - ${SPACING_REGULAR}px - 256px)`, '256px'],
    rows: ['auto', 'auto'],
    areas: [
      ['title', 'projectId'],
      ['organization', 'projectType'],
    ],
    alignContent: 'center',
  }),
  gridColumnGap: SPACING_REGULAR,
  gridRowGap: SPACING_UNIT / 2,
});

const Title = styled(Typography)({
  ...gridLayoutItem('title'),
  fontSize: 16,
});
Title.defaultProps = { variant: 'body2' };

const ProjectId = styled(Typography)({
  ...gridLayoutItem('projectId', { justifySelf: 'end' }),
  marginLeft: SPACING_REGULAR,
});
ProjectId.defaultProps = { variant: 'caption' };

const ProjectTypeValue = styled(Typography)({
  ...gridLayoutItem('projectType'),
  width: '100%',
  textAlign: 'right',
});
ProjectTypeValue.defaultProps = { variant: 'body2' };

const ChipAndOrganization = styled('div')({
  ...gridLayoutItem('organization'),
  ...gridLayoutContainer({
    columns: ['auto', '1fr'],
    rows: ['auto'],
    areas: [['chip', 'organizationName']],
    alignContent: 'center',
  }),
});

const OrganizationName = styled(OrganizationNameWithIcon)({
  ...gridLayoutItem('organizationName'),
});

const CompetitionChip = styled(Chip)({
  ...gridLayoutItem('chip'),
  marginRight: SPACING_UNIT,
  height: '28px',
  minWidth: '100px',
});

export default OfferListItemHeader;
